import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import OnBoarding from '../components/OnBoarding';
import Start from '../components/Start';
import MedicalInfo from '../components/MedicalInfo';
import Videoconference from '../components/Videoconference/Main';
import Header from '../components/Utilities/Header'; 
import '../styles/OneToOne.scss';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../styles/_toast.scss';

import { Modal, ModalProgress, ModalConfirm, ModalConfirm2 } from '../components/Utilities/Modal';

import SessionRefuse from '../assets/images/session_refuse.png';
import Loader from '../components/Utilities/Loader';

export function withRouter(Children) {
    return (props) => {
        const match = { params: useParams() };
        return <Children {...props}  match={match} />
    }
}

class OneToOne extends React.Component {
	
	state = {
		session: {},
		step: 'welcome',
		notifications: [],
		isKilled: false,
		doc2uState: window.sdk.getHocoSettings() && window.sdk.getHocoSettings().available_devices && window.sdk.getHocoSettings().available_devices.indexOf('doc2u') > -1 ? true : false
	}
	
	async componentDidMount() {

		window.sdk.event().on('welcome', () => {
			this.setState({
				step: 'welcome'
			})
		});
		window.sdk.event().on('medicalInfo', () => {
			this.setState({
				step: 'medicalInfo'
			})
		});
		window.sdk.event().on('onBoarding', () => {
			this.setState({
				step: 'onBoarding'
			})
		});

		window.sdk.event().on('browserOverdated', () => {
			this.setState({
				step: 'browserOverdated'
			})
		});

		window.sdk.checkBrowser();

		window.sdk.event().on('waitingAdminValidation', () => {
			this.setState({
				step: 'waitingAdminValidation'
			})
		})

		window.sdk.event().on('iAmValidate', () => {
			this.setState({
				step: 'welcome'
			})
		})

		window.sdk.event().on('iAmRefuse', () => {
			this.setState({
				step: 'refuseAdminValidation'
			})
		})		

		window.sdk.event().on('removeNotification', (socketId) => {
			for(var i in this.state.notifications) {
				if(this.state.notifications[i].data.socketId == socketId)
					delete this.state.notifications[i];
			}
			this.forceUpdate();
		})
		

		window.sdk.event().on('newSessionToValidate', (data) => {
			this.state.notifications.push({
				action: 'newSessionToValidate',
				data
			});
			this.forceUpdate();
		})
		
		window.sdk.event().on('toast', (params = {}) => {
			let defaultParams = {
				position: toast.POSITION.TOP_CENTER,
				autoClose: 5000,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "light",
			}
			toast(params.message,{...defaultParams, ...params});

		})
		window.sdk.event().on('killed', (param = {}) => {
			if(param.reason == 'openInNewTab'){
				this.setState({
					isKilledNewTab: true
				})
			} 
			else if(param.reason == 'keepCurrentTab'){
				this.setState({
					isKilledKeepCurrentTab: true
				})
			}
			else {
				this.setState({
					isKilled: true
				})
			}
		})

		let session = await window.sdk.session().get(this.props.match.params);
		this.setState({
			session
		});

		document.body.classList.add('onetoone-type-'+session.name);
	}
	
	async goStep(step) {
		this.setState({
			step: step
		});
		window.sdk.videoconf().startSfuSession(this.state.doc2uState);
	}

	async validate(data) {
		await window.sdk.session().validate(data);
	}

	async cancel(data){
		await window.sdk.session().refuse(data);
		window.sdk.event().emit('removeNotification', data.socketId);
	}

	changeDoc2uState = () => {
		this.setState({
			doc2uState: !this.state.doc2uState
		});
	}
	
	render() {
		if(this.state.step == "browserOverdated"){
			return(
				<div className={`onetoone onetoone--${this.state.step}`}>
					<Header noIcons={true} />

					<div id="main">
						<div className={'main-inner main-inner--overdated'}>
							<div className="overdated-top">Votre navigateur internet n’est pas supporté ou sa version est trop ancienne pour utiliser nos services.</div>
							<div className="overdated-bottom">
								<p className="overdated-bottom__text">Nous vous invitons à utiliser les dernières versions de : google chrome, safari, edge, firefox ou opera.</p>
								<button className="button button--primary overdated-bottom__button" onClick={() => {window.close()}}>Retour vers la page d'accueil</button>
							</div>
						</div>
					</div>
				</div>	
			);
		}
		if (JSON.stringify(this.state.session) == '{}')
			return null;
			if(this.state.isKilledKeepCurrentTab === true) {
				return (
					<Modal title={"Vous êtes déjà connecté sur une autre fenêtre"} close={false}>
					<div className='need-interaction'>
					<div style={{marginTop:'10px'}}>
						<button className='button button--primary' onClick={() => {window.close()}} style={{margin:'10px'}}>Fermer</button>
					</div>
					</div>
					</Modal> 
				)
		}
		if(this.state.isKilledNewTab === true) {
				return (
					<Modal title={"Vous êtes déjà connecté sur une autre fenêtre"} close={false}>
					<div className='need-interaction'>
					<div style={{marginTop:'10px'}}>
						<button className='button button--primary' onClick={() => {window.close()}} style={{margin:'10px'}}>Fermer</button>
					</div>
					</div>
					</Modal> 
				)
		}

		if(this.state.isKilled === true) {
			return (
				<Modal title={"Merci !"} close={false}>
                <div className='need-interaction'>
                Cette session est terminée, vous ne pouvez plus accéder à la consultation. 
                <div style={{marginTop:'10px'}}>
                    <button className='button button--primary' onClick={() => {window.close()}} style={{margin:'10px'}}>Fermer</button>
                </div>
                </div>
                </Modal> 
			)
		}
		return (
			
			<div className={`onetoone onetoone--${this.state.step}`}>
				{ this.state.notifications.map((notification, i) => (
					<React.Fragment>
						<ModalConfirm title={(notification.data.role ? 'Un ' + notification.data.role : 'Une nouvelle personne') + ' souhaite participer à l’appel.'} 
							onConfirm={(e) => { this.validate(notification.data) }}
							onCancel={() => { this.cancel(notification.data) }}
						>
							Souhaitez-vous la laisser entrer ?
						</ModalConfirm>
					</React.Fragment>
				))}

				
				{ this.state.step == 'waitingAdminValidation' &&
					<Modal close={false} variant="waiting" title="En attente">
						<p style={{textAlign:'center'}}>
						Veuillez attendre l’autorisation du médecin pour entrer
						</p>
					</Modal>
				}

				{ this.state.step == 'refuseAdminValidation' &&
					<Modal close={false} variant="waiting" title="">
						
						<div style={{textAlign:'center'}}>
							<img src={SessionRefuse} />
							<h3 className="modal__title">L’accès à cette conversation a été refusé</h3>
							<button className='button button--primary' onClick={() => {window.sdk.exit();window.close()}} style={{margin:'10px'}}>Fermer</button>
						</div>
					</Modal>
				}

				{this.state.step == 'welcome' && 
					<Modal close={false} variant="setting" title="">
						<Start />
					</Modal>
				}

				{this.state.step == 'medicalInfo' && 
					<Modal close={false} variant="setting" title="Questionnaire médical">
						<MedicalInfo />
					</Modal>
				}

				{this.state.step == 'onBoarding' &&
					<Modal close={false} variant="setting" title="Configuration Vidéo">
						<OnBoarding onReady={ () => { this.goStep('videoconf') } } doc2uState={this.state.doc2uState} changeDoc2uState={this.changeDoc2uState}/>
					</Modal>
				}
				<Header />
				{/*<div id="header">
					ok one to one {this.state.session.name}
			</div>*/}

				<div id="main">									
					{ this.state.step == 'videoconf' &&
						<Videoconference doc2uState={this.state.doc2uState}/>
					}
				</div>
				<ToastContainer />
				{ false &&
					<Loader />
				}
			</div>
		);
	}
}

export default withRouter(OneToOne);